import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'quiz-dashboard',
        path: '/quiz-dashboard',
        component: () => import('@/pages/quiz-dashboard/QuizDashboard.vue'),
        props: true,
        meta: {
            title: 'Quiz Dashboard',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a quiz attempt'),
        },
    },
];
